import { render } from "./TestSettings.vue?vue&type=template&id=58481208&scoped=true"
import script from "./TestSettings.vue?vue&type=script&lang=js"
export * from "./TestSettings.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./TestSettings.vue?vue&type=style&index=1&id=58481208&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58481208"]])

export default __exports__